import React, { ReactNode } from 'react';
import CardList from '../CardList';
import NewsListItem, { NewsListItemPropsType } from '../NewsListItem';

export type NewsCardListPropsType = {
  title?: string;
  seeAllLink?: ReactNode;
  height?: string;
  loading?: boolean;
  fallback?: ReactNode;
  news: NewsListItemPropsType[];
};

const NewsCardList: React.FC<NewsCardListPropsType> = ({
  title,
  seeAllLink,
  news = [],
  loading = false,
  height,
  fallback,
}) => {
  return (
    <CardList
      title={title}
      seeAllLink={seeAllLink}
      loading={loading}
      height={height}
      fallback={fallback}
    >
      {news.length
        ? news.map((item, index) => <NewsListItem key={index} {...item} />)
        : fallback}
    </CardList>
  );
};

export default NewsCardList;
